import find from 'array.prototype.find';

find.shim();
